module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[],"openGraph":{"images":[{"url":"https://res.cloudinary.com/ryandaaang/image/upload/v1618392064/Site_Snapshot.png","width":1200,"height":627,"alt":"portfolio website preview"}]}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
